import React from 'react';
import PropTypes from 'prop-types';
import translate from '../translate';
import { handleClickFullScreen } from '../../services/utilityFunctions';

function FullScreenBtn({ t, id }) {
  return (
    <div className="academy-btn-fullScreen buttonFullScreen">
      <button
        type="button"
        className="btn m-btn--pill btn-dynamic"
        onClick={() => handleClickFullScreen(id)}
      >
        <i className="fa fa-expand" />
        {` ${t('academy.detail.scorm.fullscreen')}`}
      </button>
    </div>
  );
}

FullScreenBtn.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.func.isRequired,
};
FullScreenBtn.defaultProps = {
};

export default translate(FullScreenBtn);
